import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import CustomerLayout from "./customerLayout";
import Button from "../../-components/common/Button";
import { useGetTrackingDetail } from "../../../../../hooks/morning/useGetTrackingDetail";
import ModifyTracking from "../../-components/ModifyTracking";
import { usePutTrackingCancel } from "../../../../../hooks/morning/usePutTrackingCancel";
import { ReactComponent as Close } from "assets/morning/icon/close.svg";
import { usePutTrackingMemo } from "../../../../../hooks/morning/usePutTrackingMemo";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import { ReactComponent as Checked } from "assets/morning/icon/checked.svg";
import { ReactComponent as CheckedBlue } from "assets/morning/icon/checkedBlue.svg";
import { ReactComponent as Tracking } from "assets/morning/icon/tracking.svg";
import { ReactComponent as UpArrow } from "assets/morning/icon/upArrow.svg";
import { ReactComponent as Shipping } from "assets/morning/icon/shipping.svg";
import { ReactComponent as Shipping2 } from "assets/morning/icon/shipping2.svg";
import { ReactComponent as Copy } from "assets/morning/icon/copy.svg";
import { ReactComponent as StatusReception } from "assets/morning/icon/statusReception.svg";
import { ReactComponent as StatusPickUpReservation } from "assets/morning/icon/statusPickUpReservation.svg";
import { ReactComponent as StatusPickupComplete } from "assets/morning/icon/statusPickupComplete.svg";
import { ReactComponent as StatusInDelivery } from "assets/morning/icon/statusInDelivery.svg";
import { ReactComponent as StatusDeliveryCompleted } from "assets/morning/icon/statusDeliveryCompleted.svg";
import { useGetTrackingPopBill } from "../../../../../hooks/morning/useGetTrackingPopBill";
import PrintBill from "../../-components/PrintBill";
import PrintTracking from "../../-components/PrintTracking";
import { toastErrorSyle } from "hooks/utils/util";
import Spinner from "components/Spinner";
import Seo from "components/Seo";
import axios from "axios";
import { useGetMypageInfo } from "hooks/morning/useGetMypageInfo";
import { useMorningAuthStore } from "store/useMorningAuthStore";
import { useMasterAuthStore } from "store/useMasterAuthStore";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "components/ui/dialog";
import { useGetOrderFiles } from "../../../../../hooks/morning/useGetOrderFiles";

const orderStatusImg = (status: string) => {
    switch (status) {
        case "오더접수":
            return <StatusReception />;
        case "픽업예약":
            return <StatusPickUpReservation />;

        case "픽업완료":
            return <StatusPickupComplete />;

        case "배송중":
            return <StatusInDelivery />;

        case "배송완료":
            return <StatusDeliveryCompleted />;

        default:
            return null;
    }
};

const initialShowPopState = { open: false, message: "" };

const DeliveryPhoto = ({ src }: { src: string | null }) => {
    if (!src) return null;
    return (
        <Dialog>
            <DialogTrigger asChild>
                <div>
                    <p className="text-[#878A93] text-[18px] font-[500] mt-[4px] mb-5 responsive1200:text-[16px]">배송완료사진</p>
                    <figure className="w-[300px] aspect-square cursor-pointer">
                        <img src={src} alt="배송완료사진" className="w-full h-full object-cover" />
                    </figure>
                </div>
            </DialogTrigger>
            <DialogContent className="rounded-[20px] pt-14 w-full max-w-[900px] bg-white text-black border-none responsive1000:!max-w-[90%]">
                <DialogTitle hidden>배송완료사진</DialogTitle>
                <DialogDescription hidden>배송완료사진</DialogDescription>
                <div className="w-full h-auto overflow-hidden">
                    <figure className="max-h-[80dvh] overflow-auto">
                        <img src={src} alt="배송완료사진" className="w-full h-full object-cover" />
                    </figure>
                </div>
            </DialogContent>
        </Dialog>
    );
};

const MorningTrackingDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const bl_no = searchParams.get("bl_no");

    const isMaster = location.pathname.includes("master");
    const accessToken = useMorningAuthStore(state => state.accessToken ?? "");
    const isGuest = useMasterAuthStore(state => state.isGuest ?? true);
    const isLoggedIn = isMaster ? !isGuest : !!accessToken;

    const steps = ["오더접수", "픽업예약", "픽업완료", "배송중", "배송완료"];
    const [memo, setMemo] = useState<string>("");
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [trackingShow, setTrackingShow] = useState<boolean>(false);
    const [cancelShow, setCancelShow] = useState<boolean>(false);
    const [showToast, setShowToast] = useState<string>("");
    const [printBill, setPrintBill] = useState<boolean>(false);
    const responsive1200 = useMediaQuery(1200);
    const [trackingPop, setTrackingPop] = useState<boolean>(false);
    const printable = !bl_no?.startsWith("1") && !responsive1200;
    const { data: detailData, isLoading: isLoadingDetail, isError: isErrorDetail, error: errorDetail } = useGetTrackingDetail(bl_no || "");
    const { data: billData, isLoading, isError, error } = useGetTrackingPopBill(bl_no || "", printable);
    const { mutate: cancelTracking, isPending: pendingCancelTracking } = usePutTrackingCancel();
    const { mutate: memoTracking } = usePutTrackingMemo();
    const { data: infoData } = useGetMypageInfo({
        enabled: isLoggedIn,
    });
    const orderCategory = detailData?.접수idx ? `order_${detailData.접수idx}` : "";
    const { data: pickupFiles } = useGetOrderFiles(orderCategory);
    const pickupImages = (pickupFiles || []).map(f => `https://api.ilshingroup.com/pickup/${f.file_path}`);
    const [pickupModalOpen, setPickupModalOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const [showPop, setShowPop] = useState<{ open: boolean; message: string }>(initialShowPopState);
    const currentStep = Number(detailData?.진행코드?.[0]);

    const handleCancel = () => {
        const payload = {
            bl_no: bl_no || "",
        };
        cancelTracking(payload, {
            onSuccess: () => {
                setCancelShow(false);
                toast.success("접수취소 되었습니다.");
            },
            onError: (error: any) => {
                console.error(error);
                const message = error.message;
                toast.error(message, toastErrorSyle);
            },
        });
    };

    const handleMemo = () => {
        const payload = {
            idx: Number(detailData?.접수idx) || 0,
            memo: memo,
        };
        memoTracking(payload);

        setShowToast("memo");
        setTimeout(() => {
            setShowToast("");
        }, 2000);
    };

    useEffect(() => {
        setMemo(detailData?.메모 || "");
    }, [detailData]);

    useEffect(() => {
        const handleError = (errorObj: unknown, isErrorFlag: boolean) => {
            if (isErrorFlag && axios.isAxiosError(errorObj)) {
                const messageFromBackend = errorObj?.response?.data?.message;
                setShowPop({ open: true, message: messageFromBackend });
            }
        };

        handleError(error, isError);
        handleError(errorDetail, isErrorDetail);
    }, [isError, error, isErrorDetail, errorDetail]);

    const postcodePrefix = detailData?.출발지우편번호 ? parseInt(detailData.출발지우편번호.slice(0, 2), 10) : null;

    const isDaeguGyeongbukBusanGyeongNam =
        postcodePrefix !== null &&
        ((postcodePrefix >= 36 && postcodePrefix <= 43) || // 경북 + 대구
            (postcodePrefix >= 46 && postcodePrefix <= 49) || // 부산
            (postcodePrefix >= 50 && postcodePrefix <= 53)); // 경남

    return (
        <>
            <Seo type="morning" pageTitle="운송장상세" />
            <CustomerLayout>
                <div className="bg-[#f8f8f8] responsive1200:bg-white flex flex-col items-center pt-12 responsive1200:pt-0 flex-1">
                    <div className="bg-white responsive1200:bg-transparent mt-12 w-full max-w-[1200px] px-10 py-6 rounded-2xl flex flex-col items-center mb-6 responsive1200:px-[4%] responsive1200:mt-6">
                        <div className="w-full flex justify-between items-center pb-3 mb-5 border-b-2 border-black responsive1200:border-none responsive1200:justify-center">
                            <div className="flex items-center text-[22px] flex-wrap">
                                <p className="mr-2 text-[#222222] font-[500] text-nowrap">운송장번호</p>
                                <p className="mr-4 font-bold text-nowrap">{detailData?.운송장번호}</p>
                                <button
                                    onClick={() => {
                                        if (detailData?.운송장번호) {
                                            navigator.clipboard.writeText(detailData.운송장번호);
                                            setShowToast("copy");
                                            setTimeout(() => {
                                                setShowToast("");
                                            }, 2000);
                                        }
                                    }}
                                    className=" text-nowrap text-[16px] font-[500] text-[#878A93] flex items-center gap-1"
                                >
                                    <Copy />
                                    복사
                                </button>
                            </div>
                            {printable && (
                                <div className="flex gap-1">
                                    <Button
                                        onClick={() => {
                                            setPrintBill(true);
                                            setTimeout(() => {
                                                window.print();
                                                setPrintBill(false);
                                            }, 300);
                                        }}
                                    >
                                        영수증 출력
                                    </Button>
                                    {isLoggedIn && <Button onClick={() => setTrackingPop(true)}>운송장 출력</Button>}
                                </div>
                            )}
                        </div>
                        <div className="w-full border border-[#E1E2E4] rounded-xl overflow-hidden">
                            <div className="px-16 flex justify-between w-full items-center pb-8 pt-12 responsive1200:px-[20px] responsive1200:p-[16px]">
                                <div className="flex flex-col items-center -translate-y-2">
                                    <p className="text-[#1B1C1E] text-[20px]">
                                        {detailData?.진행시간}{" "}
                                        <span className="font-bold">
                                            <br className="hidden responsive1200:block" />
                                            {detailData?.진행코드[1]}
                                        </span>{" "}
                                        되었습니다.
                                    </p>
                                    <p className="text-[#878A93] text-sm font-[500]">접수일자 {detailData?.접수일자}</p>
                                </div>
                                {responsive1200 ? (
                                    <figure>
                                        <div className="bg-[#FFF3EC] rounded-[8px] flex justify-center items-center w-[56px] h-[56px]">
                                            {orderStatusImg(detailData?.진행코드[1].toString() || "")}
                                        </div>
                                        <figcaption className="text-[#FF7B2E] text-[13px] font-bold mt-[4px]">
                                            {detailData?.진행코드[1].toString()}
                                        </figcaption>
                                    </figure>
                                ) : (
                                    <div className="flex responsive1200:hidden">
                                        {steps.map((label, idx) => (
                                            <div key={idx} className="flex">
                                                {idx === currentStep - 1 ? (
                                                    <div className="flex flex-col items-center">
                                                        <div className="flex flex-col gap-4 mb-3 -translate-y-5 items-center">
                                                            <Tracking />
                                                            <Checked className="w-7 h-7 -translate-y-2 -mb-16" />
                                                        </div>
                                                        <p className="mt-[24px] font-bold text-sm text-new whitespace-nowrap">{label}</p>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col items-center mt-5">
                                                        <div className="w-2 h-2 bg-[#C2C4C8] rounded-full" />
                                                        <p className="mt-3.5 text-xs text-[#878A93] whitespace-nowrap">{label}</p>
                                                    </div>
                                                )}
                                                {idx !== steps.length - 1 && (
                                                    <div className="w-[108px] h-[1px] bg-[#C2C4C8] -mx-[17px] mt-6" />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div
                                className={`relative transition-all duration-0 ease-in-out overflow-hidden px-16 pt-7 pb-5 w-full bg-[#F7F7F8] flex flex-col gap-3 responsive1200:px-[20px] responsive1200:py-[16px] ${
                                    isOpen ? "max-h-[1000px]" : "max-h-[80px]"
                                }`}
                            >
                                {Array.isArray(detailData?.배송상세) &&
                                    detailData?.배송상세.map((item, idx) => (
                                        <div key={idx}>
                                            <div className="flex items-center justify-between responsive600:flex-col responsive600:items-start responsive600:gap-1">
                                                <div className="flex gap-5 items-center responsive600:gap-2 responsive600:flex-wrap">
                                                    {idx === detailData?.배송상세.length - 1 ? (
                                                        <CheckedBlue />
                                                    ) : (
                                                        <div className="mx-1 w-2 h-2 bg-[#C2C4C8] rounded-full" />
                                                    )}
                                                    <div
                                                        className={`${
                                                            idx === detailData?.배송상세.length - 1
                                                                ? "bg-[#0054D1] text-white"
                                                                : "border-[#0054D1] border text-[#0054D1]"
                                                        } w-[85px] shrink-0 py-1 text-sm rounded-[4px] flex items-center justify-center`}
                                                    >
                                                        {item.진행코드명}
                                                    </div>
                                                    <p className="text-[#1B1C1E] font-[500] break-keep">{item.진행담당자및주소}</p>
                                                    <p className="text-[#5A5C63] -ml-3 responsive600:ml-0 whitespace-nowrap">{item.담당자}</p>
                                                </div>
                                                <p className="text-[#878A93] text-sm whitespace-nowrap responsive600:ml-7">{item.진행시간}</p>
                                            </div>
                                            {/* 마지막 항목이 아니라면 점선 라인 추가 */}
                                            {idx !== detailData?.배송상세.length - 1 && (
                                                <div className="border-l border-dashed border-[#002966] h-[20px] ml-2 -mb-1.5 -mt-0.5" />
                                            )}
                                        </div>
                                    ))}
                                {!isOpen && (
                                    <div className="absolute bottom-0 left-0 w-full h-[50px] bg-gradient-to-t from-[#F7F7F8] to-transparent" />
                                )}
                            </div>
                            <div
                                onClick={() => setIsOpen(prev => !prev)}
                                className="cursor-pointer flex gap-2 items-center justify-center pt-2 pb-4 text-[#5A5C63] w-full bg-[#F7F7F8]"
                            >
                                {isOpen ? "배송상세 접기" : "배송상세 더보기"}
                                <UpArrow className={`${!isOpen ? "rotate-180 transition-transform" : "transition-transform"}`} />
                            </div>
                        </div>
                        <div className="flex gap-2 mt-5 responsive1200:w-full">
                            {Array.isArray(detailData?.버튼노출) &&
                                detailData?.버튼노출.map((btnLabel, idx) => (
                                    <Button
                                        onClick={() => (btnLabel === "운송장수정" ? setTrackingShow(true) : setCancelShow(true))}
                                        key={idx}
                                        className="min-h-12 w-[300px] border-none bg-[#F3F5F8] text-[#878A93] responsive1200:w-full responsive1200:flex-1"
                                    >
                                        {btnLabel}
                                    </Button>
                                ))}
                        </div>
                        {bl_no?.startsWith("1") || (
                            <p className="text-[#5A5C63] text-sm mt-2 break-keep responsive1200:text-center">
                                담당기사 픽업 이후 운송장은 수정 및 접수 취소가 불가합니다. 고객센터에 문의해주세요.
                            </p>
                        )}
                    </div>
                    {bl_no?.startsWith("1") || (
                        <>
                            <div className="bg-white w-full max-w-[1200px] px-10 py-6 rounded-2xl flex flex-col mb-6 responsive1200:px-[4%] responsive1200:rounded-none responsive1200:bg-[#F3F5F8] responsive1200:mb-0">
                                <div className="flex flex-col responsive1200:bg-white responsive1200:rounded-2xl responsive1200:px-[16px] responsive1200:py-[16px] ">
                                    <div className="w-full flex items-center pb-3 mb-5 border-b gap-2">
                                        <Shipping />
                                        <p className=" text-[#132E47] text-[20px] font-[700]">발송 및 지불 방법</p>
                                    </div>
                                    <div className="flex gap-10 responsive790:flex-col">
                                        <div className="flex flex-col flex-1">
                                            <div className="text-[18px] flex min-h-[50px] items-center">
                                                <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                    발송구분
                                                </p>
                                                <p className="text-[#132E47]">{detailData?.발송구분}</p>
                                            </div>
                                            <div className="text-[18px] flex min-h-[50px] items-center">
                                                <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                    지불방법
                                                </p>
                                                <p className="text-[#132E47]">{detailData?.지불방법}</p>
                                            </div>
                                            <div className="text-[18px] flex min-h-[50px] items-center">
                                                <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                    요금처
                                                </p>
                                                <p className="text-[#132E47]">{detailData?.요금처}</p>
                                            </div>
                                            <div className="text-[18px] flex min-h-[50px] items-center">
                                                <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                    담당자
                                                </p>
                                                <p className="text-[#132E47]">{detailData?.담당자}</p>
                                            </div>
                                            <div className="text-[18px] flex min-h-[50px] items-center">
                                                <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                    수량
                                                </p>
                                                <p className="text-[#132E47]">{detailData?.수량}</p>
                                            </div>
                                            <div className="text-[18px] flex w-full max-w-[800px] mt-3 responsive1200:flex-col">
                                                <p className="text-[#878A93] font-[500] min-w-[160px] mt-2">메모</p>
                                                <div className="w-full flex flex-col gap-6">
                                                    <textarea
                                                        value={memo}
                                                        onChange={e => {
                                                            setMemo(e.target.value);
                                                        }}
                                                        placeholder="메모를 입력해주세요.&#13;&#10;해당 메모는 접수처에만 보입니다."
                                                        className="focus:border-new focus:border-2 outline-0 text-[16px] min-h-[144px] py-3 px-4 text-[#132E47] border resize-none w-full rounded-lg"
                                                    />
                                                    <p className="text-right text-xs text-[#5a5c63] mb-2 mr-1">
                                                        <span className="text-new">{memo.length.toLocaleString()}</span> / 1,000
                                                    </p>
                                                    <Button
                                                        onClick={handleMemo}
                                                        className="w-full bg-[#F3F5F8] text-[#878A93] border-none min-h-[50px]"
                                                    >
                                                        저장
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>

                                        {detailData?.배송완료사진 && <DeliveryPhoto src={detailData.배송완료사진} />}
                                    </div>
                                </div>
                            </div>
                            <div className="w-full max-w-[1200px] flex gap-6 responsive1200:flex-col responsive1200:px-[4%] responsive1200:bg-[#F3F5F8] responsive1200:gap-0">
                                <div className="bg-white w-full px-10 py-6 rounded-2xl flex flex-col mb-6">
                                    <div className="w-full flex items-center pb-3 mb-5 border-b gap-2">
                                        <Shipping2 />
                                        <p className=" text-[#132E47] text-[20px] font-[700]">출발지 정보</p>
                                        {isLoggedIn && pickupImages.length > 0 && (
                                            <button
                                                onClick={() => { setSelectedImageIndex(0); setPickupModalOpen(true); }}
                                                className="ml-auto px-3 py-1.5 text-[14px] font-[500] text-white bg-[#132E47] rounded-lg hover:bg-[#1a3d5c] transition-colors"
                                            >
                                                픽업사진
                                            </button>
                                        )}
                                    </div>
                                    {pickupModalOpen && pickupImages.length > 0 && (
                                        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70" onClick={() => setPickupModalOpen(false)}>
                                            <div className="bg-white rounded-2xl p-5 max-w-[500px] w-[90%] max-h-[85vh] overflow-auto" onClick={e => e.stopPropagation()}>
                                                <div className="flex items-center justify-between mb-4">
                                                    <p className="text-[18px] font-[700] text-[#132E47]">픽업 물품사진</p>
                                                    <button onClick={() => setPickupModalOpen(false)} className="p-1">
                                                        <Close className="w-5 h-5" />
                                                    </button>
                                                </div>
                                                <div className="w-full rounded-lg overflow-hidden mb-3">
                                                    <img
                                                        src={pickupImages[selectedImageIndex]}
                                                        alt="픽업사진"
                                                        className="w-full object-contain max-h-[400px] bg-[#F3F5F8]"
                                                    />
                                                </div>
                                                {pickupImages.length > 1 && (
                                                    <div className="flex gap-2">
                                                        {pickupImages.map((url, idx) => (
                                                            <button
                                                                key={idx}
                                                                onClick={() => setSelectedImageIndex(idx)}
                                                                className={`flex-1 rounded-lg overflow-hidden border-2 transition-colors ${
                                                                    idx === selectedImageIndex ? "border-[#132E47]" : "border-transparent"
                                                                }`}
                                                            >
                                                                <img src={url} alt={`픽업사진 ${idx + 1}`} className="w-full h-[80px] object-cover" />
                                                            </button>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    <div className="flex flex-col">
                                        <div className="text-[18px] flex min-h-[50px] items-center">
                                            <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                상호
                                            </p>
                                            <p className="text-[#132E47]">{detailData?.출발지상호}</p>
                                        </div>
                                        <div className="text-[18px] flex min-h-[50px] items-center">
                                            <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                연락처
                                            </p>
                                            <p className="text-[#132E47]">{detailData?.출발지연락처}</p>
                                        </div>
                                        <div className="text-[18px] flex min-h-[50px] items-center">
                                            <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                담당자
                                            </p>
                                            <p className="text-[#132E47]">{detailData?.출발지담당자}</p>
                                        </div>
                                        <div className="text-[18px] flex min-h-[50px] mt-3 mb-6">
                                            <p className="text-[#878A93] font-[500] min-w-[160px] responsive1200:min-w-[80px] responsive1200:text-[16px]">
                                                주소
                                            </p>
                                            <p className="text-[#132E47]">{detailData?.출발지주소}</p>
                                        </div>
                                    </div>

                                    {isDaeguGyeongbukBusanGyeongNam && (
                                        <div className="flex flex-col">
                                            <div className="text-[18px] flex min-h-[50px] items-center">
                                                <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                    롤
                                                </p>
                                                <p className="text-[#132E47]">{detailData?.롤}</p>
                                            </div>
                                            <div className="text-[18px] flex min-h-[50px] items-center">
                                                <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                    박스
                                                </p>
                                                <p className="text-[#132E47]">{detailData?.박스}</p>
                                            </div>
                                            <div className="text-[18px] flex min-h-[50px] items-center">
                                                <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                    샘플
                                                </p>
                                                <p className="text-[#132E47]">{detailData?.샘플}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="bg-white w-full px-10 py-6 rounded-2xl flex flex-col mb-6">
                                    <div className="w-full flex items-center pb-3 mb-5 border-b gap-2">
                                        <Shipping2 />
                                        <p className=" text-[#132E47] text-[20px] font-[700]">도착지 정보</p>
                                    </div>
                                    <div className="flex flex-col">
                                        <div className="text-[18px] flex min-h-[50px] items-center">
                                            <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                상호
                                            </p>
                                            <p className="text-[#132E47]">{detailData?.도착지상호}</p>
                                        </div>
                                        <div className="text-[18px] flex min-h-[50px] items-center">
                                            <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                연락처
                                            </p>
                                            <p className="text-[#132E47]">{detailData?.도착지연락처}</p>
                                        </div>
                                        <div className="text-[18px] flex min-h-[50px] items-center">
                                            <p className="text-[#878A93] font-[500] w-[160px] responsive1200:w-[80px] responsive1200:text-[16px]">
                                                담당자
                                            </p>
                                            <p className="text-[#132E47]">{detailData?.도착지담당자}</p>
                                        </div>
                                        <div className="text-[18px] flex min-h-[50px] mt-3 mb-6">
                                            <p className="text-[#878A93] font-[500] min-w-[160px] responsive1200:min-w-[80px] responsive1200:text-[16px]">
                                                주소
                                            </p>
                                            <p className="text-[#132E47]">{detailData?.도착지주소}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {bl_no?.startsWith("1") && detailData?.배송완료사진 && (
                        <div className="pb-20">
                            <DeliveryPhoto src={detailData.배송완료사진} />
                        </div>
                    )}

                    <div
                        className={`w-full flex justify-center responsive1200:bg-[#F3F5F8] responsive1200:px-[4%] ${bl_no?.startsWith("1") && detailData?.배송완료사진 ? "pt-[60px]" : ""}`}
                    >
                        <Button size="L" onClick={() => navigate(-1)} className="w-full max-w-[600px] min-h-12 mb-16 bg-white">
                            목록
                        </Button>
                    </div>
                </div>
                {trackingShow && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <ModifyTracking
                            done
                            idx={detailData?.접수idx || ""}
                            infoData={infoData}
                            onClose={() => {
                                setTrackingShow(false);
                            }}
                        />
                    </div>
                )}
                {cancelShow && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="bg-white overflow-hidden rounded-2xl relative w-[560px] px-10">
                            <div className="flex justify-between items-center w-full pt-10 pb-6">
                                <p className="text-2xl text-[#1B1C1E] font-[500]">운송장 취소</p>
                                <Close className="cursor-pointer" onClick={() => setCancelShow(false)} />
                            </div>
                            <p className="text-[#1B1C1E] text-lg">
                                담당기사 픽업완료 상태 전까지 취소하실 수 있습니다. <br />
                                취소하시겠습니까?
                            </p>
                            <div className="w-full flex gap-2 mt-8 mb-10">
                                <Button className="w-full" size="L" onClick={() => setCancelShow(false)}>
                                    나가기
                                </Button>
                                <Button className="w-full bg-new border-none text-white" size="L" onClick={handleCancel}>
                                    접수취소
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
                {showToast && (
                    <div className="fixed bottom-8 left-1/2 transform items-center justify-center flex -translate-x-1/2 bg-[#132e47] w-[560px] text-white text-[18px] font-[500] py-3.5 rounded-2xl shadow-md z-10">
                        {showToast === "copy" ? "클립보드에 복사되었습니다." : "저장되었습니다"}
                    </div>
                )}
                {printBill && <PrintBill data={billData} onClose={() => setPrintBill(false)} />}
                {trackingPop && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <PrintTracking bl_no={detailData?.운송장출력번호} onClose={() => setTrackingPop(false)} />
                    </div>
                )}

                {showPop.open && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="absolute text-[#1b1c1e] z-[100] mt-[34px] flex flex-col gap-8 bg-white border w-[560px] p-10 rounded-lg shadow-lg overflow-hidden">
                            <div className="text-2xl flex items-center justify-between">
                                <p className="font-[600]">Error</p>
                                <Close onClick={() => setShowPop(initialShowPopState)} className="cursor-pointer" />
                            </div>
                            <p className="text-lg">{showPop.message}</p>
                            <Button
                                onClick={() => setShowPop(initialShowPopState)}
                                className="w-full border-none bg-new text-white"
                                size="L"
                            >
                                확인
                            </Button>
                        </div>
                    </div>
                )}

                {(pendingCancelTracking || isLoading || isLoadingDetail) && <Spinner />}
                <Toaster position="bottom-center" reverseOrder={false} />
            </CustomerLayout>
        </>
    );
};

export default MorningTrackingDetail;
